import { PlanType } from '@showbie-socrative/socrative-utils';

const Constants = require('../../../Constants');

const maxRosterSize = new Map<PlanType, number>([
  [PlanType.Free, Constants.MAX_FREE_ROSTERED_STUDENTS],
  [PlanType.Starter, Constants.MAX_STARTER_ROSTERED_STUDENTS],
  [PlanType.Essentials, Constants.MAX_ESSENTIALS_ROSTERED_STUDENTS],
  [PlanType.Pro, Constants.MAX_PRO_ROSTERED_STUDENTS],
  [PlanType.Organization, Constants.MAX_PRO_ROSTERED_STUDENTS],
  [PlanType.Complete, Constants.MAX_PRO_ROSTERED_STUDENTS],
]);
export function rosterLimitsByPlan(plan: PlanType) {
  return maxRosterSize.get(plan) ?? Constants.MAX_FREE_ROSTERED_STUDENTS;
}
